import { render } from "./ResumoGeralPage.vue?vue&type=template&id=3a429e80&scoped=true"
import script from "./ResumoGeralPage.vue?vue&type=script&lang=js"
export * from "./ResumoGeralPage.vue?vue&type=script&lang=js"

import "./ResumoGeralPage.vue?vue&type=style&index=0&id=3a429e80&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a429e80"]])

export default __exports__